import Vue from 'vue'

Vue.component('landing-page', require('./components/LandingPage').default);

Vue.component('tabs', require('./components/Tabs').default);
Vue.component('modal', require('./components/Modal').default);
Vue.component('slideshow', require('./components/Slideshow').default);
Vue.component('custom-navbar-menu', require('./components/Navbar'));
Vue.component('contact-us-form', require('./components/Contact').default);
Vue.component('partner-logos', require('./components/PartnerLogos').default);
Vue.component('heard-about-us-field', require('./components/HeardAboutUsField'));
// Vue.component('cookie-consent', require('./components/CockieConsent').default);

// Electrical Training Program
Vue.component('electrical-trainee-payment-details', require('./components/ElectricalTrainee/PaymentDetails').default);
Vue.component('electrical-trainee-application', require('./components/ElectricalTrainee/Application').default);
Vue.component('electrical-trainee-quarter-payments', require('./components/ElectricalTrainee/QuartersPayments'));

// Courses
Vue.component('courses-index', require('./components/Courses/Index'));
Vue.component('course-checkout-modal', require('./components/Courses/Checkout').default);

// Calendar
Vue.component('calendar', require('./components/Schedules/Calendar').default);
Vue.component('calendar-filter-button', require('./components/Schedules/CalendarFilterButton').default);
Vue.component('schedule-information-modal', require('./components/Schedules/ScheduleInformation').default);

Vue.component('quiz-app', require('./components/QuizApp/Index').default);
Vue.component('quiz-app-authentication-form', require('./components/QuizApp/Authentication').default);
Vue.component('quiz-app-authenticated-view', require('./components/QuizApp/AuthenticatedView').default);
Vue.component('quiz-app-questions-form', require('./components/QuizApp/QuestionForm').default);
Vue.component('quiz-app-question-answers', require('./components/QuizApp/Answers').default);

// Payments
Vue.component('payment-form', require('./components/Dashboard/Payments/PaymentForm').default);

// Others
// Vue.component('paginator', require('./components/Dashboard/Others/Paginator').default);
// Vue.component('submit-button', require('./components/Dashboard/Others/SubmitButton').default);

// Jobs
Vue.component('job-create', require('./components/Dashboard/Jobs/Create').default);

// Videos
Vue.component('videos-index', require('./components/Video/Index').default);
Vue.component('videos-header', require('./components/Video/Header').default);
Vue.component('videos-list', require('./components/Video/VideoList').default);

Vue.component('user-add-credit-coupon', require('./components/Dashboard/Wallet/AddCreditCoupon').default);


